/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import _ from 'lodash';
import { loadEpisodes } from '@/episode/api';

const state = {
  episodes: [],
  lastPage: 1,
  loadEpisodesListState: {
    status: 'idle',
    error: null,
  },
};

const defaultState = {
  episodes: [],
  lastPage: 1,
  loadEpisodesListState: {
    status: 'idle',
    error: null,
  },
};

const getters = {
};

const mutations = {
  setEpisodesListState(state, response) {
    // const episodes = response.data;
    // const newEpisodes = _.mapKeys(episodes, (episode) => episode.id);
    state.episodes = response.data;
    state.lastPage = response.lastPage;
  },
  setLoadEpisodesListState(state, message) {
    switch (message.type) {
      case 'loading':
        state.loadEpisodesListState.status = 'loading';
        state.loadEpisodesListState.error = null;
        break;
      case 'success':
        state.loadEpisodesListState.status = 'success';
        break;
      case 'error':
        state.loadEpisodesListState.status = 'error';
        state.loadEpisodesListState.error = message.payload;
        break;
      default:
        state.loadEpisodesListState.status = 'idle';
        state.loadEpisodesListState.error = null;
    }
  },
  destroyEpisodesList(state) {
    Object.assign(state, _.cloneDeep(defaultState));
  },
};

const actions = {
  async loadEpisodesList({ dispatch, commit }, filter) {
    try {
      commit('destroyEpisodesList');
      commit('setLoadEpisodesListState', { type: 'loading' });
      const response = await loadEpisodes(filter);
      await dispatch('setEpisodesListState', response.data);
      commit('setLoadEpisodesListState', { type: 'success' });
    } catch (error) {
      commit('setLoadEpisodesListState', {
        type: 'error',
        payload: error.response,
      });
    }
  },
  setEpisodesListState({ commit }, response) {
    commit('setEpisodesListState', response);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
